import { GridColDef, GridColumnGroupingModel } from '@mui/x-data-grid-premium';
import moment from 'moment/moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  SolaForceDataGrid,
  getFieldNamesFromColumnConfig,
} from '~/components/SolaForceDataGrid';
import {
  UseEmployeeViewActivityLogProps,
  useEmployeeViewActivityLog,
} from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/components/EmployeeActivityLog/EmployeeViewActivityLog/useEmployeeViewActivityLog';

type PropsType = UseEmployeeViewActivityLogProps;

export const EmployeeViewActivityLog = (props: PropsType) => {
  const { t } = useTranslation();

  const { rows } = useEmployeeViewActivityLog(props);

  const { columnsConfig, columnGroupingConfig } = useMemo(() => {
    const userColumnsConfig: GridColDef[] = [
      {
        field: 'userName',
        headerName: t('name'),
        minWidth: 150,
      },
      {
        field: 'userUnit',
        headerName: t('laUnit'),
        minWidth: 150,
      },
    ];
    const activityColumnsConfig: GridColDef[] = [
      {
        field: 'targetType',
        headerName: t('userActivityTargetType'),
        minWidth: 120,
      },
      {
        field: 'resourceName',
        headerName: t('userActivityTargetResource'),
        minWidth: 200,
      },
      {
        field: 'eventType',
        headerName: t('userActivityEventType'),
        minWidth: 60,
      },
    ];
    const serverColumnsConfig: GridColDef[] = [
      {
        field: 'serverTime',
        type: 'dateTime',
        headerName: t('serverTime'),
        minWidth: 160,
        renderCell: ({ value }) => {
          return moment(value).format('L LTS');
        },
      },
    ];
    const clientColumnsConfig: GridColDef[] = [
      {
        field: 'clientTime',
        type: 'dateTime',
        headerName: t('clientTime'),
        minWidth: 160,
        renderCell: ({ value }) => {
          return moment(value).format('L LTS');
        },
      },
      {
        field: 'ipAddress',
        headerName: t('ipAddress'),
        minWidth: 110,
      },
      {
        field: 'userAgent',
        headerName: t('userAgent'),
        minWidth: 200,
        flex: 1,
      },
    ];

    const columnsConfig: GridColDef[] = [
      ...userColumnsConfig,
      ...activityColumnsConfig,
      ...serverColumnsConfig,
      ...clientColumnsConfig,
    ];

    const columnGroupingConfig: GridColumnGroupingModel = [
      {
        groupId: t('user'),
        children: getFieldNamesFromColumnConfig(userColumnsConfig),
      },
      {
        groupId: t('activity'),
        children: getFieldNamesFromColumnConfig(activityColumnsConfig),
      },
      {
        groupId: t('server'),
        children: getFieldNamesFromColumnConfig(serverColumnsConfig),
      },
      {
        groupId: t('clientApplication'),
        children: getFieldNamesFromColumnConfig(clientColumnsConfig),
      },
    ];

    return {
      columnsConfig,
      columnGroupingConfig,
    };
  }, [t]);

  return (
    <SolaForceDataGrid
      columns={columnsConfig}
      rows={rows}
      columnGroupingModel={columnGroupingConfig}
      experimentalFeatures={{ columnGrouping: true }}
      hideFooter={true}
      pinnedColumns={{ left: ['userName', 'userUnit'] }}
      density={'compact'}
    />
  );
};
